import { SvgIcon, SvgIconProps } from "@mui/material";

export const NumberListIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M11 4h9M11.15 9H20M5.25 9V4L4 5.25M11 14h9M11.15 19H20M4 15a1 1 0 0 1 1-1h.614c.53 0 .999.338 1.166.84v0c.136.41.048.86-.233 1.188L4 19h3M4 9h2.5"
      />
    </svg>{" "}
  </SvgIcon>
);
